import PropTypes from "prop-types";
import { forwardRef } from "react";
import classNames from "classnames";

let TripBarItemBody = forwardRef(
  ({ as = "h6", tag: Tag = as, className, children, ...props }, ref) => (
    <Tag
      className={classNames("place", "toolbarItem-body", className)}
      ref={ref}
      {...props}
    >
      {children}
    </Tag>
  )
);

TripBarItemBody.propTypes = {
  as: PropTypes.oneOfType([PropTypes.elementType, PropTypes.string]),
  className: PropTypes.string,
  children: PropTypes.any
};

export { TripBarItemBody };
